module.exports = __webpack_public_path__ + "img/56_79.bc45d669.png";